<template>
    <div>
        <Snackbar v-if="errored" msg="Error from Server" />
        <Snackbar v-if="created" msg="Operation Successfull" />
        <v-card-title>New Category</v-card-title>
        <v-col cols="12">
        <v-form ref="form" v-model="valid">
            <v-container>
            <v-row>
                <v-col
                cols="6"
                >
                <v-text-field
                    v-model="name"
                    :rules="nameRules"
                    :loading="loading"
                    label="Name*"
                    required
                ></v-text-field>
                </v-col>

                <v-col cols="3">
                    <v-select
                    :rules="sectionRules"
                    :items="sections"
                    :loading="loading"
                    :disabled="loading"
                    label="Select a section"
                    persistent-hint
                    v-model="section"
                    ></v-select>

                </v-col>
                <v-col
                cols="3"
                >
                    <v-text-field
                        :rules="priorityRules"
                        :loading="loading"
                        v-model="priority"
                        label="Priority"
                        type="number"
                    ></v-text-field>
                </v-col>
                <v-col>
                    <v-btn
                        depressed
                        :disabled="loading"
                        :loading="loading"
                        color="primary"
                        class="mr-4"
                        @click="submit"
                        >
                        Submit
                    </v-btn>
                </v-col>
            </v-row>
            </v-container>
        </v-form>
        </v-col>
    </div>
</template>
<script>
import axios from '../../plugins/axios'
import Snackbar from '@/components/Snackbar.vue'

export default {
    name: 'NewCategory',
    components: {
        Snackbar
    },
    data: () => ({
        valid: false,
        loading: false,
        errored: false,
        created: false,
        name: '',
        section: '',
        priority: 1,
        sections: ['Publication', 'Activity', 'Member'],
        nameRules: [
            v => !!v || 'Name is required'
            // v => v.length <= 10 || 'Name must be less than 10 characters',
        ],
        sectionRules: [
            v => !!v || 'Description is required'
        ],
        priorityRules: [
            v => v >= 1 || 'Priority should be greater than 0'
        ]
    }),
    methods: {
        submit () {
            this.errored, this.created = false
            if(this.$refs.form.validate()){
                this.loading = !this.loading;
                let {name, section, priority} = this;
                axios.post(`/category/`,
                    {name, section, priority})
                    .then(() => {
                        this.created = true
                        this.$refs.form.reset()
                    })
                    .catch(err => {
                        console.error("error", err)
                        this.errored = true
                    })
                    .finally(() => {
                        this.loading = false
                    });
            }
        },
		reset () {
			this.$refs.form.reset();
        }        
    }
}
</script>